import React, { useState } from "react";
import ImageCarousel from "./ImageCarousel";
import "../Pages/Page-css/ViewVulnerabilities.css"
import Image1 from '../../Assests/ReportImages/methodology.png'
import DOMPurify from 'dompurify';

const NAV_TABS = [
    { key: "attachments", label: "Attachments" },
    { key: "affectedParameter", label: "Affected Parameter" },
    { key: "recommendations", label: "Recommendations" },
];

const ViewVulnerabilitiesAttachment = (props) => {

    const { vulnerabilityData, setVulnerabilityData, setPocImages, pocImages } = props

    const [activeTab, setActiveTab] = useState("attachments");

    const renderContent = () => {
        switch (activeTab) {
            case "attachments":
                return (
                    <ImageCarousel pocImages={pocImages} setPocImages={setPocImages} pocList={vulnerabilityData?.poc} />
                );
            case "affectedParameter":
                return (
                    <div className="tab-content">

                        <div style={{ padding: "1rem", textAlign: "left" }}>
                            {vulnerabilityData?.affectedParameter
                                ?.split(/\r?\n/)
                                .filter(line => line.trim() !== "")
                                .map((line, index) => (
                                    <p
                                        key={index}
                                        style={{ wordBreak: "break-word", fontSize: "14px", margin: "4px 0" }} >
                                        {line}
                                    </p>
                                ))}
                        </div>
                    </div>
                );
            case "recommendations":
                return (
                    <div className="tab-content">

                        <div style={{ padding: "1rem", textAlign: "left" }}>
                            <p style={{ fontSize: '14px' }}>
                                {vulnerabilityData?.recommendation ? vulnerabilityData?.recommendation.split(/(?=[•●])/).map((line, lineIndex, linesArray) => {
                                    const trimmedLine = line.trim();
                                    return (
                                        <div key={lineIndex}>
                                            {trimmedLine && (
                                                <span>
                                                    {trimmedLine}
                                                    {lineIndex < linesArray.length - 1}
                                                </span>
                                            )}
                                        </div>
                                    );
                                }) : ''}
                            </p>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <div className="attachment-navbar-tabs">
                {NAV_TABS.map((tab) => (
                    <button
                        key={tab.key}
                        className={`tab-btn${activeTab === tab.key ? " active" : ""}`}
                        style={{
                            // flex: 1,
                            // minWidth: '100px',
                            whiteSpace: "nowrap",
                            // padding: "1rem",
                            border: "none",
                            // background: activeTab === tab.key ? "#E76A34" : "transparent",
                            // color: activeTab === tab.key ? "#fff" : "#333",
                            // fontWeight: activeTab === tab.key ? "bold" : "normal",
                            borderBottom: `1px solid ${activeTab === tab.key ? "#E76A34" : "transparent"}`,
                            cursor: "pointer",
                            outline: "none",
                            transition: "background 0.2s",
                            fontSize: "14px",

                        }}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div>{renderContent()}</div>
        </div>
    );
};

export default ViewVulnerabilitiesAttachment;